import HttpClient from "../../clients/HttpClient";
import { UserGroupContract } from "../../models/UserGroupContract";

export default class UserGroupContractService {
  static httpClient: HttpClient = HttpClient.getInstance("backend", process.env.REACT_APP_API_URL);

  public static async list(params = {}): Promise<Array<UserGroupContract>> {
    return this.httpClient.get("/user_group_contracts", params).then((res) => {
      return res.data.map((row) => new UserGroupContract(row));
    });
  }

  public static async getUserGroupContract(id): Promise<UserGroupContract> {
    return this.httpClient.get(`/user_group_contracts/${id}`).then((res) => {
      return new UserGroupContract(res.data);
    });
  }

  public static async addUserGroupContract(data): Promise<UserGroupContract> {
    return this.httpClient.post(`/user_group_contracts`, data).then((res) => {
      return new UserGroupContract(res.data);
    });
  }

  public static async editUserGroupContract(id, data): Promise<UserGroupContract> {
    return this.httpClient.put(`/user_group_contracts`, data).then((res) => {
      return new UserGroupContract(res.data);
    });
  }

  public static async deleteUserGroupContract(id): Promise<boolean> {
    return this.httpClient.delete(`/user_group_contracts/${id}`, null).then((res) => {
      return true;
    });
  }

  public static async listUserGroupContractsOnUserGroup(userGroupId): Promise<Array<UserGroupContract>> {
    return this.httpClient.get("/user_groups/" + userGroupId + "/user_group_contracts").then((res) => {
      return res.data.map((row) => new UserGroupContract(row));
    });
  }
}


